<script lang="ts">
	// Genuine shadcn-svelte Button (CLI-fetched), RESTYLED to the price-check theme
	// tokens. The variant map + types live in ./button-variants.ts so plain `tsc`
	// can resolve them (the .svelte ambient only exposes a default export). Tokens
	// auto-flip in dark mode. NO arbitrary values.
	import { cn } from "../../../utils.js";
	import { buttonVariants, type ButtonProps } from "./button-variants.js";

	let {
		class: className,
		variant = "primary",
		size = "default",
		ref = $bindable(null),
		href = undefined,
		type = "button",
		disabled,
		children,
		...restProps
	}: ButtonProps = $props();
</script>

{#if href}
	<a
		bind:this={ref}
		data-slot="button"
		class={cn(buttonVariants({ variant, size }), className)}
		href={disabled ? undefined : href}
		aria-disabled={disabled}
		role={disabled ? "link" : undefined}
		tabindex={disabled ? -1 : undefined}
		{...restProps}
	>
		{@render children?.()}
	</a>
{:else}
	<button
		bind:this={ref}
		data-slot="button"
		class={cn(buttonVariants({ variant, size }), className)}
		{type}
		{disabled}
		{...restProps}
	>
		{@render children?.()}
	</button>
{/if}
